import styled from "styled-components/macro";

export const Header = styled.header(({ theme }) => ({
  width: "100%",
  padding: "16px 0 0",
  zIndex: "1",
  backgroundColor: theme.color.neutral["08"],
  [theme.breakpoint.lg()]: {
    padding: "36px 0 0",
  },
}));

export const Icons = styled.div(({ theme }) => ({
  display: "flex",
  alignItems: "baseline",
  gap: '20px',
  svg: {
    marginRight: "20px",
  },
  ".svgMobile": {
    display: "block",
  },
  ".svgDesktop": {
    display: "none",
  },

  [theme.breakpoint.lg()]: {
    svg: {
      marginRight: "40px",
    },
    ".svgMobile": {
      display: "none",
    },
    ".svgDesktop": {
      display: "block",
    },
  },
}));

export const HeaderContent = styled.div(({ theme }) => ({
  padding: "0 0 16px",
  svg: {
    maxWidth: "100px",
  },

  [theme.breakpoint.lg()]: {
    padding: "0 0 36px",
    svg: {
      maxWidth: "100%",
    },
  },

  [theme.breakpoint.xl()]: {
    padding: "0 0 36px",
  },
  "> div": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
}));
